(() => {
  const cartUrl = () => window.routes?.cart_url || '/cart';

  function updateCartUI(cart) {
    const count = Number(cart?.item_count || 0);
    document.querySelectorAll('[data-lumi-cart-count]').forEach((node) => {
      node.textContent = count;
    });
    document.querySelectorAll('[data-lumi-cart-count-sr]').forEach((node) => {
      node.textContent = `${count} item${count === 1 ? '' : 's'} in cart`;
    });
    document.querySelectorAll('[data-lumi-cart-count-bubble]').forEach((bubble) => {
      bubble.classList.toggle('is-empty', count === 0);
    });
  }

  async function refresh() {
    try {
      const response = await fetch(`${cartUrl()}.js`, { headers: { Accept: 'application/json' } });
      if (!response.ok) return null;
      const cart = await response.json();
      updateCartUI(cart);
      return cart;
    } catch (error) {
      console.warn('[Lumi cart UI]', error);
      return null;
    }
  }

  window.LumiCartUI = { refresh, update: updateCartUI };
  document.addEventListener('lumi:cart-updated', refresh);
})();
